<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" :search="search">
        <template v-slot:top>
          <v-toolbar elevation="0">
            <v-toolbar-title>Carteras</v-toolbar-title>
            <v-divider vertical class="mx-3"></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              label="Buscar"
              outlined
              dense
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="nuevaCartera">Nuevo</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.editar`]="{ item }">
          <v-btn icon @click="editarCartera(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.esInternacional`]="{ item }">
          <v-chip :color="item.esInternacional ? 'green' : 'red'" dark>
            {{ item.esInternacional ? "Internacional" : "Local" }}
          </v-chip>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="item.estado ? 'green' : 'red'" dark>
            {{ item.estado ? "Activo" : "Inactivo" }}
          </v-chip>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-form ref="form" lazy-validation>
        <v-card>
          <v-card-title>{{ getCardTitle }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="pb-0">
                <v-text-field
                  v-model="cartera_nombre"
                  label="Nombre"
                  :rules="requiredRule"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0">
                <v-text-field
                  v-model="expediente"
                  label="Expediente"
                  outlined
                  dense
                  hide-details
                  maxlength="6"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0">
                <v-switch
                  v-model="esInternacional"
                  inset
                  class="pt-0 mt-3"
                  color="primary"
                  label="Internacional"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="4" class="pt-0">
                <v-switch
                  v-model="estado"
                  inset
                  class="pt-0 mt-3"
                  color="primary"
                  label="Estado"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-6 pb-6">
            <v-btn color="primary" @click="guardar">Guardar</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="cerrarDialog">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Expedientes", value: "expediente", align: "center" },
      { text: "Internacional", value: "esInternacional", align: "center" },
      { text: "Estado", value: "estado", align: "center" },
      { text: "Editar", value: "editar" },
    ],
    requiredRule: [(v) => !!v || "Campo requerido"],
    items: [],
    dialog: false,
    id_cartera: 0,
    cartera_nombre: "",
    expediente: "",
    esInternacional: false,
    estado: false,
  }),
  computed: {
    getCardTitle() {
      return this.id_cartera == 0 ? "Nueva Cartera" : "Editar Cartera";
    },
  },
  created() {
    this.listar();
  },
  methods: {
    listar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios.get("api/Carteras/Listar", configuracion).then((response) => {
        this.items = response.data;
      });
    },
    guardar() {
      if (this.$refs.form.validate()) {
        this.id_cartera ? this.actualizarCartera() : this.crearCartera();
      }
    },
    nuevaCartera() {
      this.cerrarDialog();
      this.dialog = true;
    },
    crearCartera() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/Carteras/Crear",
          {
            nombre: this.cartera_nombre,
            expediente: this.expediente,
            esInternacional: this.esInternacional,
            estado: this.estado,
          },
          configuracion
        )
        .then(() => {
          this.listar();
          this.cerrarDialog();
        });
    },
    actualizarCartera() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          "api/Carteras/Actualizar",
          {
            id_carteras: this.id_cartera,
            nombre: this.cartera_nombre,
            expediente: this.expediente,
            esInternacional: this.esInternacional,
            estado: this.estado,
          },
          configuracion
        )
        .then(() => {
          this.cerrarDialog();
          this.listar();
        });
    },
    editarCartera(item) {
      this.id_cartera = item.id_carteras;
      this.cartera_nombre = item.nombre;
      this.expediente = item.expediente;
      this.esInternacional = item.esInternacional;
      this.estado = item.estado;

      this.dialog = true;
    },
    cerrarDialog() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.dialog = false;
      this.id_cartera = 0;

      this.cartera_nombre = "";
      this.expediente = "";
      this.esInternacional = false;
      this.estado = false;
    },
  },
};
</script>